function setScreenSize(state, newSize) {
  state.screenSize = newSize;
}

export default {
  setScreenSize
};
